export default __webpack_public_path__ + "static/media/qual.64706600.png";